import { Injectable } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Observable } from 'rxjs';
import { MstVoucher } from '../../models/mst-voucher.model';
import { MemberVoucher } from '../../models/member-voucher.model';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  constructor(private httpService: HttpService) { }

  getVoucher(params: any): Observable<any> {
    return this.httpService.get('member-voucher-list', params);
  }
  getVoucherHeaderList(params: any): Observable<any> {
    return this.httpService.get('voucher-header-list', params);
  }
  getVoucherByHeader(params: any): Observable<any> {
    return this.httpService.get('voucher-by-header', params);
  }
  getVoucherByCode(params: any): Observable<any> {
    return this.httpService.post('search-voucher-by-code', params);
  }

  getVoucherforCreate(params: any): Observable<any> {
    return this.httpService.get('voucher/create', params);
  }

  getVoucherforEdit(batchNo: any, params: any): Observable<any> {
    return this.httpService.get(`voucher/${batchNo}/edit`, params);
  }

  getGenerateVoucher(params: any): Observable<any> {
    return this.httpService.get('member-voucher-generate', params);
  }

  addVoucher(options:any): Observable<any> {
    return this.httpService.post('member-voucher-save', options);
  }

  updateVoucher(batchNo: any, data: MstVoucher): Observable<any> {
    return this.httpService.put(`voucher/${batchNo}`, data);
  }

  deleteVoucher(batch: any): Observable<any> {
    return this.httpService.delete(`voucher/${batch}`);
  }
}
